import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';


const destination = document.getElementById('root');

ReactDOM.render(
   <App />, 
  destination
)